'use client';

import React, { useState, CSSProperties } from 'react';
import { StyledBasicSearch } from './style';
import { TextField } from '@mui/material';
import { commonImage } from 'constants/images';

interface BasicSearchProps {
  initialValue?: string;
  onChange: (value: string) => void;
  onReset?: () => void;
  onSubmit?: (value: string) => void;
  style?: CSSProperties;
  className?: string;
}

export const BasicSearch: React.FC<BasicSearchProps> = ({
  initialValue = '',
  onReset,
  onSubmit,
  onChange,
  style,
  className
}) => {
  const [inputValue, setInputValue] = useState<string>(initialValue);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
    setInputValue(e.target.value);
  };

  const handleInputReset = () => {
    setInputValue('');

    if (onReset) {
      onReset();
    }
  };

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onSubmit) {
      onSubmit(inputValue);
    }
  };

  return (
    <StyledBasicSearch style={style} className={className}>
      <TextField
        type="text"
        value={inputValue}
        variant="outlined"
        placeholder="Enter search."
        onChange={handleChange}
        InputProps={{
          endAdornment: (
            <>
              {inputValue && (
                <button type="button" onClick={handleInputReset}>
                  <img src={commonImage.cancel} alt="reset" />
                </button>
              )}

              <button type="submit" onClick={handleSubmit}>
                <img src={commonImage.search} alt="search" />
              </button>
            </>
          )
        }}
        sx={{
          m: 2,
          '& .Mui-focused .MuiIconButton-root': { color: 'primary.main' }
        }}
      />
    </StyledBasicSearch>
  );
};
